import type { MouseEvent as ReactMouseEvent } from 'react';

/**
 * Returns true if the double-click target is on a layer row control that should not
 * trigger canvas focus (rename area, actions, buttons, and optionally the caret).
 */
export function shouldIgnoreLayerRowDoubleClick(e: ReactMouseEvent): boolean {
  const target = e.target as HTMLElement;
  if (
    target.closest('[data-layer-rename]') ||
    target.closest('[data-layer-caret]') ||
    target.closest('[data-layer-actions]') ||
    target.closest('button')
  ) {
    return true;
  }
  return false;
}
